import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;

  form {
    width: 100%;
    margin: 0.5rem;
  }

  > div {
    display: flex;
    margin: 8px;
    width: 100%;
  }

  span:nth-child(2) {
    color: #0e76eb;
  }

  button {
    text-transform: uppercase;
    margin-left: auto;
    display: flex;

    &:disabled {
      color: rgba(0, 0, 0, 0.65);
      cursor: not-allowed;
      background: rgba(0, 0, 0, 0.05);
    }

    &:hover {
      background: rgba(0, 0, 0, 0.05);
      color: rgba(0, 0, 0, 0.65);
      color: #40a9ff;
      background-color: #fff;
      border-color: #40a9ff;
      outline: 0;
    }
  }

  .is-danger {
    display: flex;
    color: #c9302c;
    justify-content: flex-end;
  }
`

export const TableWrapper = styled.table`
  text-align: center;
  border-collapse: collapse;
  border: 1px solid #121212;
  width: 100%;
  margin-top: 1em;

  th,
  td {
    border: 1px solid #ddd;
    padding: 0.25rem;
    &:last-child {
      width: 4rem;
    }
  }

  th {
    text-align: center;
    background-color: rgba(176, 180, 186, 0.42);
    color: #121212;
    opacity: 0.5;
  }

  tr:nth-child(even) {
    background-color: #f2f2f2;
  }
`
export const FormFieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 8px;
  width: 100%;

  section {
    border-top: 1px solid var(--foreground);
    display: inline-block;
    margin-top: 2em;

    > label {
      position: relative;
      left: 5%;
      top: -10px;
      background-color: var(--background);
      font-weight: bold;
      padding: 8px;
    }
  }

  > div {
    display: flex;
    flex-direction: row;
  }

  label {
    width: 30%;
    font-weight: bold;
  }

  input,
  select,
  textarea {
    color: #0e76eb;
    width: 70%;
    border: 1px solid rgba(176, 180, 186, 0.42);
    border-radius: 4px;
    transition: all 0.2s ease;
    background-color: transparent;
    font-size: 14px;
    outline: none;
    resize: none;
    overflow: hidden;
    text-align: left;

    &[type='number'] {
      width: 40%;
    }
  }
`
export const FormFieldIconBlock = styled.span`
  margin-left: 0.2rem;
`
